<template>
    <div class="quote" :class="{ 'has-image': !!data.file?.url, 'is-bold': data.is_bold }">
        <div class="quote-body">
            <div v-if="data.file?.url" class="quote-image">
                <a-picture :link="data.file.url" :alt="data.author || title || ''" />
            </div>
            <div v-if="data.text" class="quote-text">
                {{ data.text }}
            </div>
        </div>
        <div class="quote-author">
            <div v-if="data.author">
                <span>{{ data.author }}</span>
                <span v-if="data.details">, {{ data.details }}</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import APicture from '@core/components/picture/picture.vue';
import type { BodyVariant, QuoteToolData } from '@model/editor-js/blocks';

defineOptions({
    name: 'BlockQuote',
});

defineProps<{
    id?: string;
    data: QuoteToolData;
    variant: BodyVariant;
    title?: string;
}>();
</script>

<style lang="pcss" scoped>
.body-renderer .quote {
    margin: 48px 0;

    &.is-bold .quote-text {
        @mixin title-accent;
    }

    &.has-image {
        margin-top: 72px;

        .quote-body {
            padding: 48px 24px 24px 24px;
        }
    }
}

.body-renderer .quote-body {
    position: relative;
    background: var(--av-brand-secondary-accent);
    border: 1px solid var(--av-brand-secondary-light);
    border-radius: 8px;
    padding: 24px;
}

.body-renderer .quote-image {
    position: absolute;
    top: -40px;
    width: 80px;
    height: 80px;
    inset-inline-start: 50%;
    transform: translateX(-50%);
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid var(--av-brand-secondary-light);
}

.body-renderer .quote-text {
    @mixin title;
    text-align: center;
    color: var(--av-nav-primary);
}

.body-renderer .quote-author {
    @mixin paragraph;
    color: var(--av-fixed-secondary);
    text-align: center;
    display: block;
    margin-top: 16px;
}
</style>
